import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import i18n from 'helpers/i18n';
import Template from 'components/UI/Template/Template';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import { withRouter } from 'react-router-dom';
import { fetchEvents, getEventsCounts } from 'components/UI/Event/ducks/event';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import EventList from 'components/UI/Event/EventList';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    //backgroundColor: theme.palette.background.paper,
  },
}));

function tabTitle(title, count)
{
  if(count===undefined || count==0)
    count="0";
  return(
    <Typography variant="h3" style={{marginRight:'40px',marginBottom:'5px',color:'#222'}}><StyledBadge badgeContent={count} color="primary">{title}</StyledBadge></Typography>
  );
}

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -30,
    top: '50%',
    width: 30,
    height: 30,
    fontSize: '1rem',
    borderRadius: '180px'
  },
}))(Badge);

const styles = (theme) => {
  return {
    root: {
      minHeight: '100%',
      width: '100%',
    },
    pageTitle: {
      paddingTop: 16,
    },

    paperWrapper: {
      width: '100%',
      display: 'block',
      position: 'relative',
      '&:before': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        content: "' '",
        height: '160px',
        backgroundColor: theme.palette.primary.light,
        zIndex: -1
      }
    },
    paper: {
      backgroundColor: 'transparent',
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      maxWidth: 1024,
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: theme.spacing(4),
      '& a': {
        color: 'inherit'
      }
    },

    tabs:{
      "& .MuiTabs-indicator": {
        backgroundColor: theme.palette.primary.main,
        height: 3,
      },
    },
    tab:{
      marginRight: '50px',
    }

  };
};
class EventsPageCategories extends Component {
  constructor(props) {
    super(props);
    //this.state = { activePanel: this.getTabFromHash() };
  }

  getTabFromHash=()=> {
    if(window.location.hash===undefined)
      return 0;
    const hash=window.location.hash.substring(1);
    const index=this.props.categories.indexOf(hash);
    if(index!==-1)
      return index;
    return 0;
  }

  componentDidMount() {
    this.props.onMount();
    //window.addEventListener("hashchange", this.hashchange, false);
  }

  componentWillUnmount() {
    //window.removeEventListener("hashchange", this.hashchange, false);
  }

  handleChange = (_event, newValue) => {
    //this.setState({activePanel: newValue});
    if(newValue in this.props.categories)
      window.location.hash = '#'+this.props.categories[newValue];
  }

  render() {
    const { classes, $$eventsCounts, categories } = this.props;
    //const {activePanel}=this.state;
    const activePanel=this.getTabFromHash();
    return (
      <Template current="videos">
        <Box className={classes.paperWrapper}>
          <Typography variant="h1" className={classes.pageTitle}>
            {i18n.get('videosTitle')}
          </Typography>{' '}
          <Paper square elevation={0} className={classes.paper}>

          <AppBar square elevation={0} color="transparent" position="static">
            <Tabs value={activePanel} onChange={this.handleChange} className={classes.tabs}>
              {categories.map((categ, i)=>
                <Tab key={categ} className={classes.tab} label={tabTitle(i18n.get('videosTabTitle_'+categ), $$eventsCounts.get(categ))} {...a11yProps(i)} />
              )}
            </Tabs>
          </AppBar>
          {categories.map((categ, i)=>
              <TabPanel key={categ} value={activePanel} index={i} className={classes.tabPanel}>
                <EventList kind={categ} variant="horizontal" eventCardClasses={{itemTitle: classes.itemTitle, itemDate: classes.itemDate, itemThumbnail: classes.itemThumbnail}} onCounterChange={this.onCounterChange} />
            </TabPanel>
          )}
          </Paper>
          </Box>
        </Template>
      );
    }
  }

  function mapStateToProps(state) {
    const props = {
      $$eventsCounts: getEventsCounts(state),
    };
    return props;
  }
  function mapDispatchToProps(dispatch, props) {
    return {
      onMount: () => {
        props.categories.forEach(categ => {
          dispatch(fetchEvents({kind:categ}));
        });
      },
    };
  }

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EventsPageCategories)));



// WEBPACK FOOTER //
// ./src/components/UI/Event/EventsPageCategories.jsx